import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EventsRoutingModule } from './events-routing.module';
import { EventPageComponent } from './components/event-page/event-page.component';
import { EventListComponent } from './components/event-list/event-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { IonicModule } from '@ionic/angular';
import { EventAddComponent } from './components/event-add/event-add.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { BsDatepickerModule, DatepickerModule } from 'ngx-bootstrap';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { EventRejectComponent } from './components/event-reject/event-reject.component';
import { RemarksComponent } from './remarks/remarks.component';

@NgModule({
  declarations: [
    EventPageComponent,
    EventListComponent,
    EventAddComponent,
    EventRejectComponent,
    RemarksComponent,
  ],
  imports: [
    CommonModule,
    EventsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatDatepickerModule,
    NgxMaterialTimepickerModule,
    IonicModule.forRoot(),
    NgxMatSelectSearchModule,
    DatepickerModule,
    BsDatepickerModule.forRoot(),
    CKEditorModule,
  ],
  entryComponents: [EventAddComponent],
})
export class EventsModule {}
